import { render, staticRenderFns } from "./SceneInfoDialog.vue?vue&type=template&id=60c89d0f&scoped=true"
import script from "./SceneInfoDialog.vue?vue&type=script&lang=js"
export * from "./SceneInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./SceneInfoDialog.vue?vue&type=style&index=0&id=60c89d0f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c89d0f",
  null
  
)

export default component.exports